import SignInForm from "../Atomic/Organisms/SignInForm";

const LogUI = () => {
  return <SignInForm />
};

export default LogUI;